<template>
  <div class="login">
    <div class="container" v-if="isForgotPasswordShow == 1">
      <div class="title">登录</div>
      <div class="userPassWordContainer">
        <div>
          <input type="text" v-model="phone" placeholder="用户名" />
        </div>
        <div>
          <input type="password" v-model="password" placeholder="密码" />
        </div>
      </div>
      <div class="loginBtn" @click="userLogin">登录</div>
      <div class="userSettingWap">
        <div @click="routePush">忘记密码</div>
        <router-link to="/registered?type=1">
          <div>注册</div>
        </router-link>
      </div>
    </div>
    <div class="container" v-else>
      <div class="title">忘记密码</div>
      <div class="userPassWordContainer">
        <div>
          <input type="text" v-model="forgotPassword.phone" placeholder="手机号" />
        </div>
        <div class="style_">
          <input type="text" v-model="forgotPassword.verificationCode" placeholder="验证码" class="inputStyle" />
          <span @click="getCode">
            {{ this.show ? "获取验证码" : this.count }}
          </span>
        </div>
        <div>
          <input type="password" v-model="forgotPassword.passWord" placeholder="设置密码" />
        </div>
        <div>
          <input type="password" v-model="forgotPassword.determinePassWord" placeholder="再次输入密码" />
        </div>
      </div>
      <div class="loginBtn" @click="loginGo">完成</div>
    </div>
  </div>
</template>

<script>
import { userLogin, smsTemplateSendMsgSecond, userFindPassWord } from "../api/interfaceList.js";
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";

export default {
  name: "login",
  data() {
    return {
      show: true,
      count: "",
      timer: null,
      phone: "",
      password: "",
      isForgotPasswordShow: 1,
      forgotPassword: {
        passWord: "",
        determinePassWord: "",
        phone: "",
        verificationCode: "",
      },
    };
  },
  created() {
    console.log(this.$route.query.isForgotPasswordShow)
    this.isForgotPasswordShow = this.$route.query.isForgotPasswordShow ? this.$route.query.isForgotPasswordShow : 1
  },
  computed:{
    isquery(){
      return this.$route.query.isForgotPasswordShow
    }
  },
  watch:{
    isquery(value){
      this.isForgotPasswordShow = value ? value : 1
    }
  },
  methods: {
    routePush() {
      this.$router.push({
        path: "/login",
        query: {
          isForgotPasswordShow: 2,
        },
      });
    },
    loginGo() {
      if (this.forgotPassword.passWord == this.forgotPassword.determinePassWord) {
        userFindPassWord({
          passWord: this.forgotPassword.passWord,
          phone: this.forgotPassword.phone,
          verificationCode: this.forgotPassword.verificationCode,
        }).then((res) => {
          if (res.code == 1) {
            ElMessage({
              message: res.message,
              type: "success",
            });
            this.isForgotPasswordShow = 1
            // router.push({
            //   path:'/userAccountSettings',
            // });
            return false;
          } else {
            ElMessage(res.message);
          }
        });
      } else {
        ElMessage({
          message: "密码不一致",
          type: "warning",
        });
      }
    },
    getCode() {
      if (this.forgotPassword.phone) {
        smsTemplateSendMsgSecond({
          phone: this.forgotPassword.phone,
          type: 5,
        }).then((res) => {
          if (res.code == 1) {
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            ElMessage(res.message);
          }
        });
      } else {
        ElMessage("请输入手机号");
      }
    },
    userLogin() {
      let { phone, password } = this;
      userLogin({
        phone,
        password,
      }).then((res) => {
        if (res.code == 1) {
          this.$store.commit('isLoginSetting', false)
          Cookies.set("userInformation", JSON.stringify(res.data))
          if (
            res.data.isEnterpriseAuthentication == 1 ||
            res.data.isPersonalAuthentication == 1
          ) {
            this.$router.push("/");
          } else {
            this.$router.push("registered");
          }
        } else {
          ElMessage({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
  },
  components: {},
};
</script>

<style lang="scss" scope>
.login {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../assets/images/loginBackimg.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .userSettingWap {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    div {
      font-size: 12px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      cursor: pointer;
      margin-left: 20px;
    }
  }

  .container {
    width: 432px;
    padding: 50px 36px 36px 36px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .loginBtn {
      width: 100%;
      height: 48px;
      line-height: 48px;
      background: #008aea;
      border-radius: 8px;
      text-align: center;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #ffffff;
      margin-top: 20px;
    }

    .userPassWordContainer {
      width: 100%;

      div:first-of-type {
        margin-top: 0;
      }

      .style_ {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: none;
        padding: 0;
      }

      .inputStyle {
        border: 1px solid #cccccc;
        border-radius: 6px;
        padding: 0 8px;
        box-sizing: border-box;
      }

      div {
        width: 100%;
        height: 40px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #cccccc;
        padding: 0 8px;
        box-sizing: border-box;
        margin-top: 20px;


        span {
          width: 80px;
          height: 40px;
          background: #008aea;
          border-radius: 6px;
          margin-left: 16px;
          line-height: 40px;
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #ffffff;
          cursor: pointer;
          text-align: center;
          margin-left: 20px;
          flex-shrink: 0;
        }

        input {
          width: 100%;
          height: 100%;
          outline: none;
          border: none;
          background: none;
        }
      }
    }

    .title {
      width: 100%;
      font-size: 30px;
      font-family: AlibabaPuHuiTiB;
      color: #000000;
      font-weight: 700;
      text-align: center;
      margin-bottom: 30px;
    }
  }
}
</style>
